/** Abstraction to use safety code context */
export const SafetyCodeContext = {
  Parental: 'parental',
  Purchase: 'purchase',
} as const;

export type SafetyCodeContext =
  (typeof SafetyCodeContext)[keyof typeof SafetyCodeContext];
